<template>
  <div :id="`m${message.id}`" v-observe-visibility="{
    callback: onVisibilityChanged,
    once: true,
    intersection: {
      threshold: 1
    }
  }">
    <div v-if="isShowDay" :class="$style.day">
      <span :class="$style.dayDate">{{ date }}</span>
    </div>
    <div
      v-if="!message.deleted"
      :class="[
        $style.container,
        { [$style.containerPicked]: isPicked },
        { [$style.containerIsMy]: isMy },
        { [$style.containerPending]: message.isPending },
        'gl-message-container'
      ]"
      @click="$emit('pick', message)"
    >
      <BaseIcon
        name="check"
        :class="[$style.checkIcon, { [$style.checkIconActive]: isPicked }]"
      />
      <div :class="$style.avatarContainer" v-if="!isMy">
        <Avatar v-if="isShowAvatar" :size="40" :user="user" @click.stop.native="showProfile" />
      </div>
      <div :class="[
        $style.messageContainer,
        { [$style.serviceMessage]: message.type === 0 },
        { [$style.messageContainerIsMy]: isMy && message.type !== 0 },
        { [$style.messageWithoutBorders]: $options.TYPE_NAME[message.type] === 'attachment' || $options.TYPE_NAME[message.type] === 'video' || $options.TYPE_NAME[message.type] === 'photo' || $options.TYPE_NAME[message.type] === 'giphy' },
        { [$style.messageContainerIsGroupLast]: isShowAvatar },
      ]" @click="handleSelection">
        <div :class="[$style.messageContainerLeft]">
          <div v-if="isShowUserName && !isMy" :class="$style.name">
            <span @click.stop="showProfile" :style="nameStyle">{{ name }}</span>
          </div>
          <template v-if="replyTo">
            <MessageReply
              :theme="isMy ? 'green' : 'white'"
              :message="replyTo"
              @click.native.stop="$emit('scroll-to-msg', replyTo.id)"
            />
            <div v-if="replySubject" :class="$style.reSubject">
              re {{ $t('chat.subject') }}: {{ replySubject }}
            </div>
          </template>
          <MessageContent v-if="message" v-bind="{ message, isForwarded, theme: isMy ? 'green' : 'white' }" />
        </div>
        <div v-if="message.type !== 0" :class="[$style.messageContainerRight]">
          <div :class="$style.sideInfo">
            <div :class="$style.sideInfoTop">
<!--              <BaseIcon-->
<!--                v-if="!isForwarded && isMy"-->
<!--                :name="envelopeIcon"-->
<!--                :class="[$style.envelope, { [$style.pending]: message.isPending }]"-->
<!--              />-->
              <div v-if="!isForwarded && isMy" :class="$style.messageIcon">
                <img v-if="this.message.properties && this.message.properties.isRead" src="../../../assets/img/open.png" alt="message">
                <img v-else src="../../../assets/img/closed.png" alt="message">
              </div>
              <span :class="$style.time" @click.stop="$emit('reply')">{{ time }}</span>
            </div>
            <div v-if="message.properties && message.properties.isEdited">{{ $t('chat.edited') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar'
import { format } from '@/utils/date'
import MessageReply from './MessageReply'
import { getUserDisplayName, getColorById } from '@/utils/helpers'
import MessageContent from './MessageContent/index.vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import { mapActions } from 'vuex'
import { TYPE_NAME } from '@/models/Message'

export default {
  name: 'message',
  TYPE_NAME,
  components: {
    Avatar,
    MessageReply,
    MessageContent
  },
  directives: {
    ObserveVisibility
  },
  props: {
    message: Object,
    isShowDay: Boolean,
    isPicked: Boolean,
    isForwarded: Boolean,
    isGrouped: Boolean,
    isShowUserName: Boolean,
    isShowAvatar: Boolean
    // isPending: Boolean
  },
  computed: {
    user () {
      return this.$store.getters['entities/users/find'](this.message.senderId)
    },
    name () {
      if (!this.user) return
      return getUserDisplayName(this.user)
    },
    colors () {
      if (!this.user) return
      return getColorById(this.user.userId)
    },
    nameStyle () {
      if (!this.colors) return
      return `color: ${this.colors[0]}`
    },
    time () {
      return format(new Date(this.message.created + 'Z'), 'hh:mm a')
    },
    date () {
      return format(new Date(this.message.created + 'Z'), 'd MMMM')
    },
    isHideUser () {
      return !this.isShowDay && this.isGrouped
    },
    isMy () {
      return this.message.senderId === this.$store.state.auth.user.id
    },
    isHideUserAvatar () {
      return !this.isShowDay && this.isShowAvatar
    },
    isHideUserUserName () {
      return !this.isShowDay && this.isShowUserName
    },
    envelopeIcon () {
      return this.message.properties && this.message.properties.isRead ? 'envelope-open' : 'envelope'
    },
    replyTo () {
      return this.message.properties && this.message.properties.replyTo
    },
    replySubject () {
      return this.replyTo && this.replyTo.properties && this.replyTo.properties.subject
    }
  },
  methods: {
    ...mapActions({
      read: 'entities/messages/read'
    }),
    showProfile () {
      this.$modal.show('profile', {
        userId: this.user.userId,
        chatId: this.message.chatId
      })
    },
    handleSelection (e) {
      const isTextHighlighting = window.getSelection().toString().trim() !== ''
      if (isTextHighlighting) {
        e.stopPropagation()
      }
    },
    onVisibilityChanged (isVisible) {
      if (this.isMy || this.isForwarded || !isVisible) return
      this.read(this.message)
    }
  }
}
</script>

<style module lang="scss">
.day {
  text-align: center;
  margin: 24px 0 12px;
  color: $text-lightest;
  &Date {
    background-color: rgba($main-bg-colored, 0.45);
    padding: 6px 15px;
    border-radius: 15px;
  }
}
.container {
  display: flex;
  padding: 2px 50px;
  cursor: pointer;
  position: relative;
  align-items: flex-end;

  &Picked {
    transition: none;
    background-color: rgba($main-bg-colored, 0.2);
  }
  &Icon:hover .checkIcon {
    opacity: 0 !important;
  }
  &:global(.highlighted) {
    transition: all 0.3s;
    background-color: rgba($main-bg-colored, 0.2);
  }
  &Forwarded {
    padding-left: 0;
  }
  &Pending {
    opacity: 0.8;
  }
}
.checkIcon {
  opacity: 0;
  position: absolute;
  top: 6px;
  left: 16px;
  font-size: 16px;
  color: $text-colored;
  &Active {
    opacity: 1;
  }
}
.messageContainerLeft{
  overflow: hidden;
  padding-right: 10px;
}

.container:not(.containerForwarded):hover > .checkIcon {
  opacity: 0.5;
  &Active {
    opacity: 1;
  }
}
.avatarContainer {
  // padding-top: 12px;
  padding-right: 14px;
  flex-shrink: 0;
  width: 54px;
}
.messageContainer {
  background: $main-bg-dark;
  width: auto;
  max-width: 80%;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.serviceMessage {
  margin: 0 auto;
  .messageContainerLeft {
    padding-right: 0;
  }
}
.messageContainerIsMy{
  background: $green;
  color: $white;
  .sideInfo{
    color: $white;
  }
  .envelope {
    color: rgba($blue, 0.7);
  }
  blockquote{
    border-color: $white;
  }
  a{
    color: $white;
  }
  &.messageContainerIsGroupLast{
    position: relative;
    &::after{
      left: auto;
      right: -8px;
      bottom: 0;
      border-color: transparent transparent $green $green;
    }
  }
  .reSubject{
    color: $white;
  }
}
.messageContainerIsGroupLast{
  position: relative;
  &::after{
    content: '';
    position: absolute;
    left: -8px;
    bottom: 0;
    width: 0;
    height: 0;
    border: 7px solid;
    border-color: transparent $main-bg-dark $main-bg-dark transparent;
  }
}
.sideInfo {
  flex-shrink: 0;
  color: $text-light;
  font-size: 12px;
}
.name {
  font-weight: 500;
  color: $text-colored;
  text-transform: capitalize;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.messageIcon {
  display: flex;
  align-self: stretch;
  align-items: center;
  img {
    margin-right: 2px;
    width: 15px;
    height: 15px;
  }
}
.envelope {
  margin-right: 2px;
  color: rgba($blue, 0.4);
  &.pending {
    color: $text-light;
  }
}
.time {
  display: inline-block;
  min-width: 35px;
  text-align: right;
  white-space: nowrap;
  &:hover {
    text-decoration: underline;
  }
}
.reSubject {
  font-size: 12px;
  font-weight: 500;
  color: $text-mid;
}
.containerIsMy{
  display: flex;
  justify-content: flex-end;
}
.sideInfoTop{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.messageWithoutBorders {
  padding: 0 !important;
  position: relative;
  .name{
    padding: 8px;
  }
  .time{
    background: rgba($text-colored, .4);
    color: #fff;
    min-width: auto;
    padding: 2px 5px;
    border-radius: 10em;
  }
  .sideInfo {
    position: absolute;
    bottom: 5px;
    right: 5px;
  }
  .messageContainerLeft {
    padding-right: 0;
  }

  &.messageContainerIsGroupLast {
    &::after {
      display: none;
    }
  }
}
</style>
